import MarkdownIt from 'markdown-it';
import {NotificationResponsePayload} from '../models/api';

export const capitalize = (string: string | undefined): string => {
  if (!string?.length) {
    return '';
  }
  return string.charAt(0).toLocaleUpperCase() + string.slice(1).toLocaleLowerCase();
};

export function capitalizeAndAddDot(str?: string | null): string {
  if (!str?.length) {
    return '';
  }
  return str.charAt(0).toUpperCase() + '.';
}

export function capitalizeLastWord(stringWithWords: string) {
  if (!stringWithWords) return stringWithWords;
  const wordsInArray = stringWithWords.split(' ');
  wordsInArray[wordsInArray.length - 1] = capitalizeAndAddDot(wordsInArray[wordsInArray.length - 1]);
  const newStringWithWords = wordsInArray.join(' ');
  return newStringWithWords;
}

export function urlProtocolSet(str: string): string {
  const quotesRegExp = /"/gm;
  while (str.match(quotesRegExp)) str = str.replace('"', '');

  const httpPrefix = 'http://';
  const startsWithHttp = /^(http|https):\/\//gm;
  if (!str.match(startsWithHttp)) {
    return httpPrefix.concat(str);
  }

  return str;
}

export function MixedTextToHtmlOnly(MixedText: string | undefined): string | undefined {
  const regExpOpenHtmlTag = /(&lt;)/g;
  const regExpCloseHtmlTag = /(&gt;)/g;
  let textToRenderInHtml;
  if (MixedText !== undefined) {
    const md = new MarkdownIt({breaks: true});
    textToRenderInHtml = md.render(MixedText);
    return textToRenderInHtml.replace(regExpOpenHtmlTag, '<').replace(regExpCloseHtmlTag, '>');
  }
  return MixedText;
}

export function requestIdfromNotificationTextTopic(
  notificationFromProps: NotificationResponsePayload,
): RegExpMatchArray | null {
  const notificationTypeRegisteredCheck: RegExp = /(Ваше обращение №(\d+) зарегистрировано)/gm;
  const notificationTypeAnsweredCheck: RegExp = /(Поступил ответ на Ваше обращение № (\d+))/gm;
  const regExpReqNum = /\d+/g;
  if (notificationFromProps.text !== undefined) {
    if (notificationFromProps.text.search(notificationTypeRegisteredCheck) > -1) {
      return notificationFromProps.text.match(regExpReqNum);
    }
  }
  if (notificationFromProps.topic !== undefined) {
    if (notificationFromProps.topic.search(notificationTypeAnsweredCheck) > -1) {
      return notificationFromProps.topic?.match(regExpReqNum);
    }
  }
  return null;
}

export function requestIdfromNotificationText(notificationText: string | undefined): RegExpMatchArray | undefined {
  if (notificationText === undefined) return;
  const notificationTypeCheck = /(Ваше обращение №(\d+) зарегистрировано)/gm;
  const regExpReqNum = /\d+/g;
  if (notificationText.search(notificationTypeCheck) > -1) {
    return notificationText.match(regExpReqNum)!;
  }
}

export function numToPostfix(value: number, words: string[]) {
  const absValue = Math.abs(value);
  value = absValue % 100;
  var num = value % 10;
  if (value > 10 && value < 20) return words[2];
  // eslint-disable-next-line no-bitwise
  if ((num > 1 && num < 5) || absValue % ~~absValue !== 0) return words[1];
  if (num === 1) return words[0];
  return words[2];
}

export const leadingZeroesRegex = /^0+(?!$)/;

export const digitsOnlyRegex = /^\d+$/;

export const allFillStopColorRegex = /(fill|stop-color)="(#[0-9A-Fa-f]{3,6}|rgb\([^)]*\)|[a-zA-Z]+)"/g;
